import { coursesChangesReducers } from '@myStore/courses-changes/courses-changes.reducers';
import { coursesViewReducers } from '@myStore/courses-view/courses-view.reducers';
import { ESDPChangesReducers } from '@myStore/ESDP-changes/ESDP-changes.reducers';
import { eventsChangesReducers } from '@myStore/events-changes/events-changes.reducers';
import { eventsViewReducers } from '@myStore/events-view/events-view.reducers';
import { groupsChangesReducers } from '@myStore/groups-changes/groups-changes.reducers';
import { groupsViewReducers } from '@myStore/groups-view/groups-view.reducers';
import { periodsChangesReducers } from '@myStore/periods-changes/periods-changes.reducers';
import { periodsViewReducers } from '@myStore/periods-view/periods-view.reducers';
import { profileChangesReducers } from '@myStore/profile-changes/profile-changes.reducers';
import { profileViewReducers } from '@myStore/profile-view/profile-view.reducers';
import { profileReducers } from '@myStore/profile/profile.reducers';
import { salesChangesReducers } from '@myStore/sales-changes/sales-changes.reducers';
import { salesViewReducers } from '@myStore/sales-view/sales-view.reducers';
import { studentResultsViewReducers } from '@myStore/student-results-view/student-results-view.reducers';
import { studentsPerformanceReducers } from '@myStore/students-performance/students-performance.reducers';
import { themeReducers } from '@myStore/theme/theme.reducer';
import { usersChangesReducers } from '@myStore/users-changes/users-changes.reducers';
import { usersViewReducers } from '@myStore/users-view/users-view.reducers';
import { workDebtorsReducers } from '@myStore/work-debtors/work-debtors.reducers';
import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import { IAppState } from './app.state';
import { authReducers } from './auth/auth.reducers';
import { coursesReducers } from './courses/courses.reducers';
import { eventsReducers } from './events/events.reducers';
import { groupsReducers } from './groups/groups.reducers';
import { mailingsReducers } from './mailings/mailings.reducers';
import { materialsReducers } from './materials/materials.reducers';
import { notificationsReducers } from './notifications/notifications.reducers';
import { studentWorksReducers } from './student-works/student-works.reducer';
import { userReducers } from './users/user.reducers';
import { ESDPViewReducers } from '@myStore/ESDP-view/ESDP-view.reducers';
import { accountantsViewReducers } from '@myStore/accountants/view/accountants-view.reducers';
import { companiesViewReducers } from '@myStore/companies/view/companies-view.reducers';
import { companiesChangesReducers } from '@myStore/companies/changes/companies-changes.reducers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const appReducers: ActionReducerMap<IAppState, any> = {
  router: routerReducer,
  users: userReducers,
  auth: authReducers,
  courses: coursesReducers,
  groups: groupsReducers,
  notifications: notificationsReducers,
  materials: materialsReducers,
  events: eventsReducers,
  mailings: mailingsReducers,
  studentWorks: studentWorksReducers,
  profile: profileReducers,
  theme: themeReducers,
  coursesView: coursesViewReducers,
  coursesChanges: coursesChangesReducers,
  groupsView: groupsViewReducers,
  groupsChanges: groupsChangesReducers,
  usersView: usersViewReducers,
  usersChanges: usersChangesReducers,
  periodsView: periodsViewReducers,
  periodsChanges: periodsChangesReducers,
  studentsPerformance: studentsPerformanceReducers,
  eventsView: eventsViewReducers,
  eventsChanges: eventsChangesReducers,
  studentResultsView: studentResultsViewReducers,
  profileView: profileViewReducers,
  profileChanges: profileChangesReducers,
  workDebtors: workDebtorsReducers,
  ESDPView: ESDPViewReducers,
  ESDPChanges: ESDPChangesReducers,
  salesChanges: salesChangesReducers,
  salesView: salesViewReducers,
  accountantsView: accountantsViewReducers,
  companiesView: companiesViewReducers,
  companiesChanges: companiesChangesReducers,
};
